import { render } from "./information-copy.vue?vue&type=template&id=13e3ae56&lang=pug"
import script from "./information-copy.vue?vue&type=script&lang=js"
export * from "./information-copy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__